import React from 'react';

const JobCardSkeleton = () => {
  return (
    <li className="job-card skeleton">
      <div className="job-link">
        <h2 className="h3 job-title">
          <span className="skeleton-text skeleton-title"></span>
        </h2>
        <div className="job-loc">
          <span className="skeleton-text skeleton-loc"></span>
        </div>
        <div className="job-meta">
          <span className="skeleton-text skeleton-meta"></span>
          <span className="skeleton-text skeleton-meta"></span>
          <span className="skeleton-text skeleton-meta"></span>
        </div>
      </div>
    </li>
  );
};

export default JobCardSkeleton;
